import Swal from 'sweetalert2';
import { history } from '../store'

const alert = {
  success: (message) => {
    return Swal.fire({
      title: 'Sucesso!',
      text: message,
      icon: 'success',
      timer: 3000,
      showConfirmButton: false,
      timerProgressBar: true,
      allowOutsideClick: false
    })
    // .then((result) => {
    //   if (result.dismiss === Swal.DismissReason.timer) {
    //     history.push(path_to_redirect)
    //   }
    // });
  },
  error: (message) => {
    return Swal.fire({
      title: 'Ops!',
      html: message,
      icon: 'error',
      confirmButtonText: 'Tentar Novamente'
    })
  },
  warning: (props = {}) => {
    return Swal.fire({
      title: 'Tem certeza ?',
      text: 'Essa ação não poderá ser desfeita',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      ...props
    })
  }
}

export default alert;